export const makeGrid = (num: number, size: string = "auto") =>
  Array.from(new Array(num))
    .map(() => size)
    .join(" ");
